var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10 1H7.545a4.09 4.09 0 0 0-4.09 4.09v2.455H1v3.273h2.455v6.546h3.272v-6.546h2.455L10 7.545H6.727V5.091c0-.452.367-.818.818-.818H10V1Z",
    stroke: "#F77A64",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFacebook;